import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import settingsEnglish from "./english";
import settingsTurkish from "./turkish";

const CURRENT_LANGUAGE = process.env.REACT_APP_CURRENT_LANGUAGE;
/**
 * settings use for manage different languages data
 */
const lanSettings = {
  en: settingsEnglish,
  tr: settingsTurkish,
};

export const useCurrentLanguage = () => {
  const { language } = useContext(AppContext);
  return lanSettings[language || CURRENT_LANGUAGE];
};

const useCorrectLanguage = (text_en, text_tr) => {
  const { language } = useContext(AppContext);
  return language === 'tr' ? text_tr : text_en;
};

export default useCorrectLanguage;